import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export default function ButtonAnnuler({onClick }) {
  return (
    <Box  sx={{ '& button': { m: 1, backgroundColor: '#B9B8B8;', color: 'white', textTransform: 'none' } }}>
     
      <div>
        <Button variant="contained" size="small" onClick={onClick}>
          Annuler
        </Button>
      </div>
    </Box>
  );
}